import { render, staticRenderFns } from "./BoardViewOptions.vue?vue&type=template&id=1431387a&scoped=true"
import script from "./BoardViewOptions.vue?vue&type=script&lang=js"
export * from "./BoardViewOptions.vue?vue&type=script&lang=js"
import style0 from "./BoardViewOptions.vue?vue&type=style&index=0&id=1431387a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431387a",
  null
  
)

export default component.exports